import script from "./MatchupsTableForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchupsTableForm.vue?vue&type=script&setup=true&lang=ts"

import "./MatchupsTableForm.vue?vue&type=style&index=0&id=5b90828a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b90828a"]])

export default __exports__